import { Header, Title, Subtitle } from './HeaderSection.style';
import BackgroundHeader from '../../assets/background-header.png';

const HeaderSection = ({
  title,
  subtitle
}) => {
  return (
    <Header>
    <Title>{title}</Title>
    <Subtitle>{subtitle}</Subtitle>
    <img src={BackgroundHeader} alt="Background" />
  </Header>
  )
}

export default HeaderSection;